import { render, staticRenderFns } from "./MNav.vue?vue&type=template&id=badf53bc&scoped=true"
import script from "./MNav.vue?vue&type=script&lang=js"
export * from "./MNav.vue?vue&type=script&lang=js"
import style0 from "./MNav.vue?vue&type=style&index=0&id=badf53bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badf53bc",
  null
  
)

export default component.exports